<p
  class="tw-mt-5 tw-px-5 tw-pb-0.5 tw-font-sans tw-text-sm tw-text-eerie-black sm:tw-mt-10 sm:tw-px-0 sm:tw-text-base"
>
  {{ 'screens.deceasedMoreInformation.requiredFields' | translate }}
</p>

<form
  (ngSubmit)="deceasedMoreInformationFacade.onNext()"
  [formGroup]="deceasedMoreInformationFacade.deceasedMoreInformationForm"
  iaInvalidControlScroll
  class="tw-flex tw-flex-col"
>
  <ia-panel class="tw-mt-4">
    <div header class="">
      <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
        'screens.deceasedMoreInformation.information.title' | translate
      }}</span>
    </div>
    <div content class="tw-px-8 tw-pb-6 tw-pt-5">
      <p class="tw-font-sans tw-text-sm sm:tw-text-base">
        {{ 'screens.deceasedInformation.information.description' | translate }}
      </p>

      <div class="tw-mt-5 tw-w-75 tw-max-w-full">
        <label
          id="label-deceased-more-information-deceased-date"
          for="input-deceased-more-information-deceased-date"
          class="tw-font-sans tw-text-base tw-font-semibold"
          >{{ 'screens.deceasedMoreInformation.information.deceasedDate.label' | translate }}</label
        >
        <ia-datepicker
          [containerClass]="{
            '!tw-border-imperial-red':
              deceasedMoreInformationFacade.deceasedDate.invalid &&
              deceasedMoreInformationFacade.deceasedDate.touched,
            'tw-border-geyser':
              deceasedMoreInformationFacade.deceasedDate.untouched ||
              deceasedMoreInformationFacade.deceasedDate.valid,
            'tw-mt-2.5 tw-block tw-flex-1 tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-left tw-shadow-inner': true,
          }"
          [maxDate]="successionFacade.today"
          [placeholder]="'JJ/MM/AAAA'"
          formControlName="deceasedDate"
          id="input-deceased-more-information-deceased-date"
        />
        @if (
          deceasedMoreInformationFacade.deceasedDate.touched &&
          deceasedMoreInformationFacade.deceasedDate.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedMoreInformation.information.deceasedDate.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-5">
        <span
          id="label-deceased-more-information-documents"
          class="tw-font-sans tw-text-base tw-font-semibold"
          >{{ 'screens.deceasedMoreInformation.information.documents.label' | translate }}</span
        >
        <p class="tw-mt-4 tw-font-sans tw-text-sm tw-text-gray">
          {{ 'screens.deceasedMoreInformation.information.documents.recommandation' | translate }}
        </p>
        @if (deceasedMoreInformationFacade.deathCertificateAttachmentGroup$ | async) {
          <ia-succession-document-row
            class="tw-pt-6"
            [documentAttachmentGroup]="
              deceasedMoreInformationFacade.deathCertificateAttachmentGroup$ | async
            "
            [selfCareTypeDocuments]="
              deceasedMoreInformationFacade.deathCertificateTypeDocuments$ | async
            "
            formControlName="deathCertificateDocuments"
            id="label-deceased-death-certificate-documents"
          />
        }
        @if (
          deceasedMoreInformationFacade.deathCertificateDocuments.touched &&
          deceasedMoreInformationFacade.deathCertificateDocuments.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{
              'screens.deceasedMoreInformation.information.deathCertificateDocuments.error'
                | translate
            }}
          </p>
        }
        @if (deceasedMoreInformationFacade.otherAttachmentGroup$ | async) {
          <ia-succession-document-row
            class="tw-mt-7.5 tw-border-t tw-border-geyser tw-pt-7.5"
            [documentAttachmentGroup]="deceasedMoreInformationFacade.otherAttachmentGroup$ | async"
            [selfCareTypeDocuments]="
              deceasedMoreInformationFacade.otherSelfCareTypeDocuments$ | async
            "
            formControlName="otherDocuments"
            id="label-deceased-other-documents"
          />
        }
      </div>

      <div class="tw-mt-7.5 tw-border-t tw-border-geyser tw-pt-7.5">
        <span
          id="label-deceased-more-information-funeral-contract"
          class="tw-pb-4 tw-font-sans tw-text-base tw-font-semibold"
          >{{
            'screens.deceasedMoreInformation.information.funeralContract.label' | translate
          }}</span
        >
        @for (object of successionFacade.listBoxItems.yesNoIdk; track object; let index = $index) {
          <ia-radio-button
            aria-describedby="hasFuneralContract"
            class="first-letter:tw-uppercase"
            type="radio"
            [value]="object.value"
            groupName="hasFuneralContract"
            name="hasFuneralContract"
            formControlName="hasFuneralContract"
            [id]="'input-deceased-more-information-funeral-contract-' + index"
            data-test-id="input-deceased-more-information-funeral-contract"
          >
            {{ object.label }}
          </ia-radio-button>
        }
        @if (
          deceasedMoreInformationFacade.hasFuneralContract.touched &&
          deceasedMoreInformationFacade.hasFuneralContract.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedMoreInformation.information.funeralContract.error' | translate }}
          </p>
        }

        <p
          class="tw-pt-3 tw-font-sans tw-text-sm tw-text-gray"
          [innerHTML]="
            'screens.deceasedMoreInformation.information.funeralContract.information1' | translate
          "
        ></p>
        <p class="tw-pt-3 tw-font-sans tw-text-sm tw-text-gray">
          {{
            'screens.deceasedMoreInformation.information.funeralContract.information2' | translate
          }}
        </p>
      </div>

      @if (deceasedMoreInformationFacade.hasFuneralContract.value === 'YES') {
        <div class="tw-mt-5">
          <span
            id="label-deceased-more-information-optional-documents"
            class="tw-pb-4 tw-font-sans tw-text-base tw-font-semibold"
            >{{
              'screens.deceasedMoreInformation.information.optionalDocuments.label' | translate
            }}</span
          >
          @if (deceasedMoreInformationFacade.funeralHomeBillsAttachmentGroup$ | async) {
            <ia-succession-document-row
              class="tw-pt-6"
              [documentAttachmentGroup]="
                deceasedMoreInformationFacade.funeralHomeBillsAttachmentGroup$ | async
              "
              [selfCareTypeDocuments]="
                deceasedMoreInformationFacade.funeralHomeBillsTypeDocuments$ | async
              "
              formControlName="funeralHomeBillsDocuments"
              id="input-deceased-more-information-home-bills-documents"
            />
          }
          @if (deceasedMoreInformationFacade.ribAttachmentGroup$ | async) {
            <ia-succession-document-row
              [documentAttachmentGroup]="deceasedMoreInformationFacade.ribAttachmentGroup$ | async"
              [selfCareTypeDocuments]="deceasedMoreInformationFacade.ribTypeDocuments$ | async"
              class="tw-mt-6 tw-border-t tw-border-geyser tw-pt-6"
              formControlName="ribDocuments"
              id="input-deceased-more-information-rib-documents"
            />
          }
          @if (
            deceasedMoreInformationFacade.funeralHomePaymentAuthorizationAttachmentGroup$ | async
          ) {
            <ia-succession-document-row
              class="tw-mt-6 tw-border-t tw-border-geyser tw-pt-6"
              [documentAttachmentGroup]="
                deceasedMoreInformationFacade.funeralHomePaymentAuthorizationAttachmentGroup$
                  | async
              "
              [selfCareTypeDocuments]="
                deceasedMoreInformationFacade.funeralHomePaymentAuthorizationTypeDocuments$ | async
              "
              formControlName="funeralHomePaymentAuthorizationDocuments"
              id="input-deceased-more-information-funeral-documents"
            />
          }
        </div>
      }</div
  ></ia-panel>

  @if (
    {
      isLoading: successionFacade.customerInformationIsLoading$ | async,
      isPrevious: successionFacade.isPreviousPageLoading$ | async,
      isNext: successionFacade.isNextPageLoading$ | async,
    };
    as vm
  ) {
    <div
      class="tw-mt-5 tw-flex tw-flex-col tw-items-center tw-justify-end tw-space-y-2 sm:tw-flex-row sm:tw-space-x-2 sm:tw-space-y-0"
    >
      <button
        (click)="deceasedMoreInformationFacade.onPrevious()"
        iaButton
        type="button"
        id="btn-deceased-more-information-previous"
        data-test-id="btn-deceased-more-information-previous"
        variant="secondary"
        [disabled]="vm.isLoading"
        [isProcessing]="!!vm.isLoading && !!vm.isPrevious"
      >
        {{ 'screens.deceasedMoreInformation.buttons.buttonPrevious.title' | translate }}
      </button>
      <button
        iaButton
        type="submit"
        id="btn-deceased-more-information-next"
        data-test-id="btn-deceased-more-information-next"
        variant="primary"
        [disabled]="vm.isLoading"
        [isProcessing]="!!vm.isLoading && !!vm.isNext"
      >
        {{ 'screens.deceasedMoreInformation.buttons.buttonNext.title' | translate }}
      </button>
    </div>
  }
</form>
